import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const STATUS_OPTIONS = [
  {
    label: 'پرداخت نشده',
    value: 'پرداخت نشده',
  },
  {
    label: 'لغو شده قبل از پرداخت',
    value: 'لغو شده قبل از پرداخت',
  },
  {
    label: 'پرداخت شده',
    value: 'پرداخت شده',
  },
  {
    label: 'بسته شده',
    value: 'بسته شده',
  },
  {
    label: 'مسترد شده',
    value: 'مسترد شده',
  },
];

const PAYMENT_OPTIONS = [
  {
    label: 'پیامک با اعتبار',
    value: 'پیامک با اعتبار',
  },
  {
    label: 'مستقیم',
    value: 'مستقیم',
  },
  {
    label: 'پرداخت در شعبه',
    value: 'پرداخت در شعبه',
  },
  {
    label: 'پرداخت با سپرده بانکی',
    value: 'پرداخت با سپرده بانکی',
  },
  {
    label: 'درگاه کارت اعتباری بانک پاسارگاد',
    value: 'درگاه کارت اعتباری بانک پاسارگاد',
  },
  {
    label: 'پرداخت با پایا',
    value: 'پرداخت با پایا',
  },
  {
    label: 'پرداخت با درگاه اقساطی',
    value: 'پرداخت با درگاه اقساطی',
  },
  {
    label: 'برداشت وجه مستقیم پاسارگاد',
    value: 'برداشت وجه مستقیم پاسارگاد',
  },
  {
    label: 'چک',
    value: 'چک',
  },
  {
    label: 'پرداخت با ترمینال (پوز)',
    value: 'پرداخت با ترمینال (پوز)',
  },
  {
    label: 'درگاه پاسارگاد',
    value: 'درگاه پاسارگاد',
  },
  {
    label: 'پرداخت در سیستم',
    value: 'پرداخت در سیستم',
  },
  {
    label: 'پرداخت از طریق مراجعه به بانک',
    value: 'پرداخت از طریق مراجعه به بانک',
  },
  {
    label: 'برداشت از سپرده توسط انتقال وجه',
    value: 'برداشت از سپرده توسط انتقال وجه',
  },
  {
    label: 'پرداخت با کارت در cms',
    value: 'پرداخت با کارت در cms',
  },
  {
    label: 'اعتبار',
    value: 'اعتبار',
  },
];

const SHAPARAK_OPTIONS = [
  {
    label: 'بله',
    value: 1,
  },
  {
    label: 'خیر',
    value: 0,
  },
];

const PAYABLE_OPTIONS = [
  {
    label: 'بله',
    value: 1,
  },
  {
    label: 'خیر',
    value: 0,
  },
];

const filters = (guildOptions = [] , currencyText) => [
  {
    title: 'محدوده تاریخ صدور',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {
        minDate: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(366, 'days'),
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      end: {
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
    },
    disableDelete: true,
  },
  {
    title: 'شناسه فاکتور',
    label: 'شناسه فاکتور',
    keyName: 'invoiceId',
    id: 1349,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'شماره کارت',
    label: 'شماره کارت',
    keyName: 'cardNumber',
    id: 2426,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'محدوده‌ مبلغ قابل پرداخت',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'amountPayable',
    id: {
      start: 1350,
      end: 1351,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'محدوده تاریخ پرداخت',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateDo',
    id: {
      start: 1445,
      end: 1446,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {
        minDate: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(366, 'days'),
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      end: {
        maxDate: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
    },
  },
  {
    title: 'براساس وضعیت فاکتور',
    label: 'وضعیت فاکتور',
    keyName: 'status',
    id: 1352,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_OPTIONS,
    },
  },
  {
    title: 'بر اساس حساب تفصیلی',
    label: 'حساب تفصیلی',
    keyName: 'guildId',
    id: 1575,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: guildOptions,
    },
     disableDelete: false,
  },
  {
    title: 'وضعیت تسهیم',
    label: 'انتخاب وضعیت تسهیم',
    keyName: 'hasMultiInvoice',
    id: 1384,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        { value: 'بلی', label: 'دارای تسهیم' },
        { value: 'خیر', label: 'بدون تسهیم' },
      ],
    },
  },
  {
    title: 'براساس نوع پرداخت',
    label: 'نوع پرداخت',
    keyName: 'paymentType',
    id: 2430,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: PAYMENT_OPTIONS,
    },
  },
  {
    title: 'تسویه شاپرک',
    label: 'تسویه شاپرک',
    keyName: 'shaparakPayment',
    id: 2432,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: SHAPARAK_OPTIONS,
    },
  },
  {
    title: 'قابل برداشت',
    label: 'قابل برداشت',
    keyName: 'payable',
    id: 2433,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: PAYABLE_OPTIONS,
    },
  },
];

export default filters;
